import { render, staticRenderFns } from "./roundChart1.vue?vue&type=template&id=58742a75&scoped=true"
import script from "./roundChart1.vue?vue&type=script&lang=js"
export * from "./roundChart1.vue?vue&type=script&lang=js"
import style0 from "./roundChart1.vue?vue&type=style&index=0&id=58742a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58742a75",
  null
  
)

export default component.exports